import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppLayoutService } from '../../app-layout.service';
import { IHeaderBadge, IHeaderStatus } from '../../interfaces';

@Component({
  selector: 'app-header-badge',
  templateUrl: './header-badge.component.html',
  styleUrls: ['./header-badge.component.scss'],
})
export class HeaderBadgeComponent implements OnInit, OnDestroy {
  public badge: IHeaderBadge;

  private isDestroy: ReplaySubject<boolean> = new ReplaySubject();

  constructor(private appLayoutService: AppLayoutService) {}

  public ngOnInit(): void {
    this.appLayoutService.headerBadge$.pipe(takeUntil(this.isDestroy)).subscribe((badge) => (this.badge = badge));
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }
}
